import { RECORD_STATUS_ORDER } from './trainingStatus';
import type { AppointmentResponse, RecordStatus } from './types';

export function startOfToday(): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

/** Whole-day math against UTC midnight — avoids tz drift across midnight. */
export function daysBetween(fromIso: string, today: Date): number {
  const target = new Date(`${fromIso}T00:00:00Z`);
  const todayUtc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.floor((target.getTime() - todayUtc) / (1000 * 60 * 60 * 24));
}

/** A lapsing record that has not expired alerts as Expiring, whatever its Record Status. */
export type RecordAlertStatus = Extract<RecordStatus, 'expired' | 'expiring'>;

export type RecordAlert = {
  appointment: AppointmentResponse;
  status: RecordAlertStatus;
  /** Positive = days remaining, negative = days since expiry. */
  daysToExpiry: number;
};

/** Non-revoked appointments whose record is lapsing, Expired first then soonest expiry. */
export function listRecordAlerts(appointments: readonly AppointmentResponse[]): RecordAlert[] {
  const today = startOfToday();
  return appointments
    .flatMap((appointment) => {
      // A lapsing record always has an expiry; one without is not alertable.
      const expiresOn = appointment.record_expires_on;
      if (!appointment.record_lapsing || !expiresOn) return [];
      const status: RecordAlertStatus = appointment.record_status === 'expired' ? 'expired' : 'expiring';
      return [{ appointment, status, daysToExpiry: daysBetween(expiresOn, today) }];
    })
    .sort(
      (a, b) =>
        RECORD_STATUS_ORDER.indexOf(a.status) - RECORD_STATUS_ORDER.indexOf(b.status) || a.daysToExpiry - b.daysToExpiry
    );
}
